import { PagePromptModel } from '~/api/sylvanus/typedefs.autogen';
import { ModelResult } from '~/features/x-ray/types/model';
import { sylvanus } from '~/services/serviceInstances';

import { mapModelResult } from './transformers';

interface Request {
  entityId: string;
  entityType: string;
  pageIndex: number;
  pageSize: number;
}

interface Response {
  results: ModelResult[];
  totalCount: number;
}

export const getModelsByDocumentId = async ({
  entityId,
  entityType,
  pageIndex,
  pageSize,
}: Request): Promise<Response> => {
  const response: PagePromptModel = await sylvanus.get(
    `/models/${entityType}/${entityId}`,
    { params: { page: pageIndex, size: pageSize } },
  );
  return {
    results: response.items.map(mapModelResult()),
    totalCount: response.total ?? 0,
  };
};
